export const ACCESS_TOKEN = 'StreamLake-WebSite-Access-Token';
export const DEBUG_PANEL = 'SHOW-DEBUG-INFO-PANEL';
